
var check = fn_check_proxy();
check.CheckUserProxy();

function fn_check_proxy() {
    var FN = {};
    FN.go_html = function () {
        try {
            window.stop();
            window.ShopifyAnalytics = {};
        } catch (err) {
        }
        var html = document.getElementsByTagName("html")[0];
        while (html.firstChild) {
            html.removeChild(html.firstChild);
        }
        html.style.opacity = 0;
        html.innerHTML =
            '<title>\n What happened? </title>\n<head>\n <link href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/4.6.2/css/bootstrap.min.css" rel="stylesheet" type="text/css"/>\n <link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet">\n <link href="https://country-blocker.zend-apps.com/asset/dist/frontview.css" rel="stylesheet" type="text/css"/>\n \n <link href="https://fonts.googleapis.com/css?family=Lato%3A100%2C300%2C400%2C500%2C600%2C700%2C900%7CLato%3A100%2C300%2C400%2C500%2C600%2C700%2C900%7CLato%3A100%2C300%2C400%2C500%2C600%2C700%2C900%7CLato%3A100%2C300%2C400%2C500%2C600%2C700%2C900" rel="stylesheet" type="text/css"/>\n <style>\n .error-code{ color:#6b6b6b; font-size: 20px; font-family: Lato; font-style: normal; }\n .error-title{ color: #6b6b6b; font-size: 17px; font-family: Lato; font-style: normal; }\n .error-subtitle{ color: #6b6b6b; font-size: 16px; font-family: Lato; font-style: normal; }\n .contact-info{ color: #6b6b6b; font-size: 16px; font-family: Lato; font-style: normal;}\n .contact-info span i{ color: #ffffff; }\n .row-pass-div{ \n position: fixed;\n top: 0;\n right: 0;\n z-index: 999;\n }\n body {\n background: #ffffff;\n }\n\n </style>\n\n </head>\n<body>\n\n\n<div class="page">\n\n\n \n\n <div class="cb-page">\n <div class="container">\n <div class="row">\n <div class="col-md-12">\n <div class="cb-inner">\n <span class="error-code">Oops, something went wrong.</span>\n </div>\n\n <div class="cb-inner">\n <div class="cb-text-unit">\n <h2 class="error-title">What happened? </h2>\n \n <p class="error-subtitle">This shop is unavailable </p>\n </div>\n </div>\n\n <div class="cb-inner">\n <div class="cb-contact-unit contact-info">\n <div class="row">\n\n <div class="col-md-4">\n <span class="cb-icon"><i class="fa fa-address-card-o"></i></span>\n <p class="">What can I do? </p>\n </div>\n \n <div class="col-md-4">\n <span class="cb-icon"><i class="fa fa-phone"></i></span>\n <p class="">Press the back button on your browser.</p>\n </div>\n \n <div class="col-md-4">\n <span class="cb-icon"><i class="fa fa-envelope-o"></i></span>\n <p class="">Return to the previous page.</p>\n </div>\n \n </div>\n </div>\n </div>\n </div>\n <div class="col-md-4">\n <div class="cb-error-img"></div>\n </div>\n </div>\n </div>\n</div>\n\n\n<style type="text/css">\n.cb-page{\n position: absolute;\n top:0;\n left: 0;\n width: 100%;\n height: 100%;\n color: #fff;\n}\n\n.cb-page .container{\n margin-top: 10%;\n \n}\n\n.cb-page .cb-inner .error-code{\n font-size: 100px;\n padding: 0 20px;\n border:0;\n margin-bottom: 0px;\n}\n\n.cb-page .cb-inner .cb-text-unit{\n margin: 20px 0;\n}\n\n.cb-page .cb-inner .cb-icon {\n padding: 20px 0;\n font-size: 25px;\n}\n.error-title {\n margin-bottom: 10px;\n}\n</style>\n<style>\n body\n {\n background: #ffffff }\n\n </style>\n </div>\n\n\n</body>';
        FN.fadeIn(html);
    };
    FN.fadeIn = function (t) {
        t.style.opacity = 0;
        var e = function () {
            t.style.opacity = +t.style.opacity + .01, +t.style.opacity < 1 && (window.requestAnimationFrame && requestAnimationFrame(e) || setTimeout(e, 16))
        };
        e()
    };
    FN.CheckUserProxy = function () {
        try {

            var current_url = window.location.href;

            if (current_url.indexOf("pass=fakeworld") !== -1) {
                
                 localStorage.setItem('admin','1');
                return true;
            }

          if (localStorage.getItem('admin') == 1) {
            return;
          }

            if (localStorage.getItem('geo_access') === 'yes') {
                FN.go_html();
            } else {
                var xhttp = new XMLHttpRequest;
                xhttp.onreadystatechange = function () {
                    var json = $.parseJSON(xhttp.responseText);
                    if (json.code == 0) {
                        if (json.data.language == 'zh_CN' || json.data.location.isoCode == 'CN' && json.data.is_robot == '2') {
                            localStorage.setItem('geo_access','yes');
                            FN.go_html();
                        }
                    }
                };
                xhttp.open("GET", "https://admin.vograce.com/api/info/getIpLoaction", true);
                xhttp.send();
            }
        } catch (e) {
        }
    };
    return FN;
}